import { ImageIcon } from 'lucide-react';

// Product panel in a dark bezel. Without `src` it renders the design's grey
// placeholder, so dropping the real export in later is a one-prop change.
interface MockFrameProps {
	/** Alt text for the capture / label for screen readers. */
	label: string;
	/** Imported image (Vite asset) or absolute URL. */
	src?: string;
	/** Tailwind aspect-ratio class for the image area. */
	aspect?: string;
	/**
	 * Which one gives way when the capture and the frame disagree.
	 *
	 * `crop` holds the frame to `aspect` and cuts whatever does not fit, which
	 * is right when the capture is roughly that shape already. `hug` throws the
	 * aspect away and lets the bezel take the capture's own proportions, which
	 * is the only way to show a capture whole without stranding dead bezel
	 * around it.
	 */
	fit?: 'crop' | 'hug';
	className?: string;
}

export default function MockFrame({
	label,
	src,
	aspect = 'aspect-[16/10]',
	fit = 'crop',
	className = '',
}: MockFrameProps) {
	if (src) {
		return (
			<figure className={`lp-shot ${className}`}>
				<img
					src={src}
					alt={label}
					className={
						fit === 'hug'
							? 'block h-auto w-full rounded-[10px]'
							: `w-full rounded-[10px] object-cover object-top ${aspect}`
					}
				/>
			</figure>
		);
	}

	return (
		<figure className={`lp-shot ${className}`}>
			<div className={`lp-shot-empty w-full ${aspect}`} role="img" aria-label={label}>
				<ImageIcon className="h-10 w-10" strokeWidth={1.5} />
			</div>
		</figure>
	);
}
